var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInPersonActivation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-660 -867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9256 21.4375 34.4619 15.3125 30.1678 7.875 23.0702 7.875 20.4181 3.28125 18.1453 4.59375 20.8097 9.20894 18.0438 14 12.7234 14 10.0717 9.40625 7.79669 10.7188 10.3902 15.211 6.797 21.4375 11.0911 28.875 18.0438 28.875 21.5797 35 28.8391 35 31.2375 39.1562 33.5125 37.8438 31.0188 33.5261 34.4619 27.5625ZM31.4309 15.3125 28.6519 20.125 23.2155 20.125 20.377 15.2084 23.0956 10.5 28.6519 10.5ZM9.828 21.4375 12.6066 16.625 18.0438 16.625 20.8219 21.4375 18.0438 26.25 12.6066 26.25ZM20.377 27.6666 23.2155 22.75 28.6519 22.75 31.4309 27.5625 28.6519 32.375 23.0956 32.375Z",
    fill: "#FFFFFF",
    transform: "matrix(1.02381 0 0 1 660 867)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInPersonActivation);
export default __webpack_public_path__ + "static/media/icon-in-person-activation.798d94c62ef689af7716935388c43e5d.svg";
export { ForwardRef as ReactComponent };